import { Paper, Text } from '@mantine/core';
import { getFrequentCustomerCardStatus, type FrequentCustomerCard } from '@washday/utilities';
import { useTranslation } from 'react-i18next';

export default function FrequentCustomerCardSummary({ card, variant = 'inline' }: {
  card?: FrequentCustomerCard | null;
  variant?: 'inline' | 'banner';
}) {
  const { t } = useTranslation(['FieldName']);
  const status = getFrequentCustomerCardStatus(card);
  if (status === 'not_configured') return null;

  const content = (
    <Text
      size="sm"
      style={{ overflowWrap: 'anywhere' }}>
      <strong>{t('FieldName:frequentCustomerCard.ticketLabel')}</strong> {card?.number.trim()} ·{' '}
      {t(`FieldName:frequentCustomerCard.status.${status}`)}
    </Text>
  );

  return variant === 'banner' ? (
    <Paper withBorder radius="sm" p="sm" bg="var(--mantine-color-blue-light)" style={{ minWidth: 0 }}>
      {content}
    </Paper>
  ) : content;
}
